import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Toast, { PluginOptions } from "vue-toastification";
import "vue-toastification/dist/index.css";
import "bootstrap-icons/font/bootstrap-icons.scss";
import "@/assets/app.scss";
import "bootstrap";
import i18n from "@/utils/i18n";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import Paginate from "vuejs-paginate-next";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { registerLicense } from "@syncfusion/ej2-base";
const license: string = process.env.VUE_APP_SYNCFUSION_LICENSE!;
registerLicense(license);
import { DialogComponent } from "@syncfusion/ej2-vue-popups";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-vue-grids/styles/material.css";
import "@syncfusion/ej2-vue-buttons/styles/material.css";
import "@syncfusion/ej2-vue-popups/styles/material.css";

library.add(fas, fab, far);

const options: PluginOptions = {
  timeout: 3500,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: false,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
};

createApp(App)
  .component("v-select", vSelect)
  .component("FontAwesomeIcon", FontAwesomeIcon)
  .component("ejs-dialog", DialogComponent)
  .use(store)
  .use(i18n)
  .use(router)
  .use(Toast, options)
  // .use(Paginate)
  .mount("#app");
